import React, { forwardRef, useState, useEffect } from "react";
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import Close from "../images/close-pdf.png"
import callingAPI from "../service"
import RealizedHeader from "./realized-report-pdf-header";
// import { FaRegWindowClose } from "react-icons/fa";
import { useSelector } from "react-redux";

const TransactionDetailsPdf = forwardRef((props, ref) => {
    const dashboardDetails = useSelector((state) => state.Dashboard);
    const reportDetails = useSelector((state) => state.report.transaction);
    const [transactionSummery, setTransactionSummery] = useState([])
    const [clientAddressDetails, setClientAddressDetails] = useState({
        building: "48 Burj Gate",
        street: "Sheikh Zayed Road",
        citya: "Dubai",
        countrya: "United Arab Emirates",
        officeno: "801",
        trnno: "",
        mobile: "919961727479",
        postbox: "119930"
    });
    const [tableData, setTableData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(12);
    const refreshToken = dashboardDetails.refreshToken;
    const windowHeight = window.innerHeight
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '21cm', // A4 paper height in cm
        width: '100%',
        margin: '0 auto',
        padding: '0 15px 0 15px', // 15px left and right padding, 2cm padding bottom for the footer
        position: 'relative',
        fontFamily: 'Roboto Medium',
        color: '#000',
        fontSize: '13px',
        boxSizing: 'border-box' // Ensures padding doesn't affect the width
    };

    const htmlBodyStyle = {
        width: '100%',
        margin: '0',
        padding: '0',
        overflowX: 'hidden' // Hides horizontal scroll globally
    };

    const mainStyle = {
        flex: '1',
        marginBottom: '1cm',
    };

    const headerStyle = {
        backgroundColor: '#004080',
        color: '#fff',
        fontSize: '14px',
        fontFamily: 'Roboto Regular',
        fontWeight: 'normal',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        verticalAlign: 'middle',
        textAlign: 'center',
    };

    const tdStyle = {
        background: '#f5f5f5',
        borderBottom: '1px solid #ccc',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: '5px 10px',
        color: '#333',
        fontSize: '12px',
    };

    const totalRowStyle = {
        background: '#fff',
        color: '#000',
        fontWeight: 'bold',
        textAlign: 'right',
        fontSize: '12px',
        padding: '10px',
    };

    const footerStyle = {
        borderTop: '2px solid #d5d5d5',
        textAlign: 'center',
        fontSize: '12px',
        padding: '10px 0',
        margin: 0,
    };
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0]; // Converts to YYYY-MM-DD format
    };
    const formatAmount = (amount) => {
        const formattedAmount = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(amount)) || 0);
        return Number(amount) < 0 ? `(${formattedAmount})` : formattedAmount;
    };
    useEffect(() => {
        setTransactionSummery(Array.isArray(reportDetails.groupedArray) ? reportDetails.groupedArray : []); // Ensure it's an array
        setClientAddressDetails(reportDetails?.clientAddressDetails || clientAddressDetails); // Use dynamic data or fallback to sample
    }, [reportDetails]);

    useEffect(() => {
        const generateTableData = () => {
            const rows = [];
            transactionSummery?.forEach((item) => {
                const { stockName, records, longshortflag } = item;

                rows.push({ stockName, isCurrencyRow: true });
                records.forEach((transaction) => {
                    rows.push(transaction);
                });
            });

            setTableData(rows);
        };

        generateTableData();
    }, [transactionSummery]);

    const paginateTableData = (data, rowsPerPage) => {
        const paginatedData = [];
        for (let i = 0; i < data.length; i += rowsPerPage) {
            const page = data.slice(i, i + rowsPerPage);
            // Only add page if it has visible content
            if (page.length > 0 && page.some(row => row.comments || row.tranDate || row.debit || row.credit || row.balance)) {
                paginatedData.push(page);
            }
        }
        return paginatedData;
    };

    const paginatedTableData = paginateTableData(tableData, rowsPerPage);
    const formattedDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const fromDate = formattedDate(props.fromDate); // format 'fromDate'
    const toDate = formattedDate(props.toDate); // format 'toDate'

    return (
        <div ref={ref} id="pdf-content">
            <div style={containerStyle} >
                <div style={mainStyle}>
                    <div>
                        {console.log("paginatedTableData22", paginatedTableData)}
                        {paginatedTableData.map((page, pageIndex) => {
                            const hasContent = page.length > 0;
                            return (
                                <div
                                    key={pageIndex}
                                    style={{
                                        pageBreakAfter: pageIndex < paginatedTableData.length - 1 ? 'always' : 'auto',
                                        pageBreakInside: 'avoid',
                                        padding: '0',
                                        margin: '0',
                                    }}
                                >
                                    <header>
                                        <RealizedHeader headerName="Transaction" clientAddressDetails={clientAddressDetails} fromDate={fromDate} toDate={toDate} />
                                    </header>
                                    <hr />
                                    <main style={{ minHeight: '440px', pageBreakInside: 'avoid', padding: '0' }}>
                                        <table
                                            className="table"
                                            style={{
                                                width: '100%',
                                                borderCollapse: 'collapse',
                                                pageBreakInside: 'avoid',
                                            }}
                                        >
                                            <thead>
                                                <tr style={headerStyle}>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Tran Date</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Settlement Date</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Buy/Sell Flag</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Long/Short Flag</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Shares</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Avg Price</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Amount</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Balance Shares</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Cost Price</th>
                                                    <th style={{ ...headerStyle, width: '10%' }}>Cost Value</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {page.map((row, index) => (
                                                    <React.Fragment key={index}>
                                                        {row.isCurrencyRow ? (
                                                            <tr style={{ backgroundColor: '#e7f3fe' }}>
                                                                <td colSpan={12} className="td-colors bg-white border-0 table-split-head moble-thead-change">
                                                                    {row.stockName}
                                                                </td>
                                                            </tr>
                                                        ) : row.comments === 'TOTAL' ? (
                                                            <tr style={{ borderBottom: '1px solid #fff', background: '#d9edf7' }}>
                                                                <td style={totalRowStyle} colSpan={3}>TOTAL</td>
                                                                <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                                    <span style={{ color: Number(row.debit) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.debit)}
                                                                    </span>
                                                                </td>
                                                                <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                                    <span style={{ color: Number(row.credit) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.credit)}
                                                                    </span>
                                                                </td>
                                                                <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                                    <span style={{ color: Number(row.balance) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.balance)}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            // <tr style={{ backgroundColor: row.comments.includes('error') ? '#f8d7da' : '#fff' }}>
                                                            <tr>
                                                                <td style={tdStyle}>{row.tranDate}</td>
                                                                <td style={tdStyle}>{row.settlementDate}</td>
                                                                <td style={tdStyle}>{row.buySellFlag}</td>
                                                                <td style={tdStyle}>{row.longShortFlag}</td>
                                                                <td style={{ ...tdStyle, textAlign: "right" }}>
                                                                    <span style={{ color: Number(row.Shares) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.Shares)}
                                                                    </span>
                                                                </td>
                                                                <td style={{ ...tdStyle, textAlign: "right" }}>
                                                                    <span style={{ color: Number(row.avgPrice) < 0 ? '#E43740' : 'black' }}>
                                                                        {Number(row.avgPrice) < 0
                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(row.avgPrice)) || 0)})`
                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(row.avgPrice) || 0)}
                                                                    </span>
                                                                    {/* <span style={{ color: Number(row.avgPrice) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.avgPrice)}
                                                                    </span> */}
                                                                </td>
                                                                <td style={{ ...tdStyle, textAlign: "right" }}>
                                                                    <span style={{ color: Number(row.amount) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.amount)}
                                                                    </span>
                                                                </td>

                                                                <td style={{ ...tdStyle, textAlign: "right" }}>
                                                                    <span style={{ color: Number(row.balanceShares) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.balanceShares)}
                                                                    </span>
                                                                </td>
                                                                <td style={{ ...tdStyle, textAlign: "right" }}>
                                                                    <span style={{ color: Number(row.costPrice) < 0 ? '#E43740' : 'black' }}>
                                                                        {Number(row.costPrice) < 0
                                                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(row.costPrice)) || 0)})`
                                                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(row.costPrice) || 0)}
                                                                    </span>
                                                                    {/* <span style={{ color: Number(row.costPrice) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.costPrice)}
                                                                    </span> */}
                                                                </td>
                                                                <td style={{ ...tdStyle, textAlign: "right" }}>
                                                                    <span style={{ color: Number(row.costValue) < 0 ? '#E43740' : 'black' }}>
                                                                        {formatAmount(row.costValue)}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </main>
                                    {hasContent && (
                                        <footer style={footerStyle}>
                                            <div>A Subsidiary of DUBAI INVESTMENTS</div>
                                            <div>
                                                {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                                                Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                                            </div>
                                            <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno}</div>
                                            <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                                            <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                                        </footer>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

            </div>
        </div>
    )
});

export default TransactionDetailsPdf;